/* @refresh reload */
import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";
import App from "./App";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import RaceCard from "./pages/RaceCard";
import Predictions from "./pages/Predictions";
import Pricing from "./pages/Pricing";
import Login from "./pages/Login";
import ProtectedRoute from "./pages/ProtectedRoute";
import { CookiePolicy, PrivacyPolicy, RefundPolicy, TermsOfUse } from "./pages/Legal";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import "./styles.css";

render(
  () => (
    <Router root={App}>
      <Route path="/" component={Landing} />
      <Route path="/app" component={() => <ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/races/:raceId" component={() => <ProtectedRoute paid><RaceCard /></ProtectedRoute>} />
      <Route path="/predictions" component={() => <ProtectedRoute paid><Predictions /></ProtectedRoute>} />
      <Route path="/pricing" component={Pricing} />
      <Route path="/login" component={Login} />
      <Route path="/privacy" component={PrivacyPolicy} />
      <Route path="/terms" component={TermsOfUse} />
      <Route path="/cookies" component={CookiePolicy} />
      <Route path="/refunds" component={RefundPolicy} />
      <Route path="/success" component={CheckoutSuccess} />
    </Router>
  ),
  document.getElementById("root")!,
);
